import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Theme,
  useMediaQuery
} from "@material-ui/core";
import React from "react";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import ApartmentRoundedIcon from "@material-ui/icons/ApartmentRounded";
import PlaceIcon from "@material-ui/icons/Place";
import PersonIcon from "@material-ui/icons/Person";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import MessageIcon from "@material-ui/icons/Message";
import GestureIcon from "@material-ui/icons/Gesture";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import HowToRegIcon from "@material-ui/icons/HowToReg";
import TrackingDetailsHeader from "./TrackingDetailsHeader";
import { makeStyles } from "@material-ui/styles";
// import ModalImage from "react-modal-image";
import theme from "../../utils/theme";
import photo from "../../assets/photo.png";
import signature from "../../assets/signature.png";
import CustomModalImage from "./CustomModalImage";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { mainPageIDs} from "../../qaIDs.json"

const useStyles = makeStyles(theme => ({
  list: {
    padding: 0,
    overflowY: "auto",
    "& .MuiDivider-root:last-child": {
      display: "none"
    },
    [theme.breakpoints.down("md")]: {
      overflowY: "initial"
    }
  },
  listItem: {
    alignItems: "flex-start",
    "& .MuiListItemIcon-root": {
      marginTop: theme.spacing(2)
    },
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(1, 3)
    }
  },
  signature: {
    "& .MuiListItemText-root": {
      paddingTop: theme.spacing(1.25)
    },
    "& .MuiListItemText-secondary": {
      height: 56,
      marginTop: theme.spacing(2.75)
    }
  },
  imgSignature: {
    maxHeight: "56px !important",
    maxWidth: "168px !important",
    objectFit: "contain"
  },
  photo: {
    "& .MuiListItemText-root": {
      paddingTop: theme.spacing(1.25)
    },
    "& .MuiListItemText-secondary": {
      "& > div": {
        display: "inline-block"
      },
      "& > div + div": {
        marginLeft: theme.spacing(1)
      }
    }
  },
  img: {
    height: 56,
    width: 56,
    marginTop: theme.spacing(2.75),
    objectFit: "cover",
    borderRadius: theme.spacing(0.5)
  },
  root: {
    width: 416,
    height: 562,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      height: "auto"
    }
  }
}));

export default function TrackingDetails({
  data,
  dataLoaded
}: {
  data: any;
  dataLoaded: boolean;
}) {
  const classes = useStyles();
  const screenSm: boolean = useMediaQuery<Theme>(theme =>
    theme.breakpoints.down("md")
  );

  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <TrackingDetailsHeader data={data} dataLoaded={dataLoaded} />
      <Divider />
      <List className={classes.list}>
        {data.information?.recipient_note && (
          <>
            <ListItem className={classes.listItem}>
              <ListItemIcon>
                <MessageIcon />
              </ListItemIcon>
              <ListItemText
                primary={t("Note for recipient")}
                secondary={data.information?.recipient_note}
              />
            </ListItem>
            <Divider />
          </>
        )}
        {data.information?.signature && (
          <>
            <ListItem className={clsx(classes.listItem, classes.signature)}>
              <ListItemIcon>
                <GestureIcon />
              </ListItemIcon>
              <ListItemText
                primary={t("Signature")}
                secondary={
                  <CustomModalImage
                    className={classes.imgSignature}
                    src={data.information.signature}
                  />
                }
              />
            </ListItem>

            <Divider />
          </>
        )}
        {!!data.information?.images?.length && (
          <>
            <ListItem className={clsx(classes.listItem, classes.photo)}>
              <ListItemIcon>
                <AddPhotoAlternateIcon />
              </ListItemIcon>
              <ListItemText
                primary={t("Photo")}
                secondary={data.information.images.map((img: string) => (
                  <CustomModalImage className={classes.img} src={img} />
                ))}
              />
            </ListItem>
            <Divider />
          </>
        )}
        {data.information?.recipient_date_of_birth && (
          <>
            <ListItem className={classes.listItem}>
              <ListItemIcon>
                <HowToRegIcon />
              </ListItemIcon>
              <ListItemText
                primary={t("Age verification")}
                secondary={data.information?.recipient_date_of_birth}
              />
            </ListItem>
            <Divider />
          </>
        )}
        {data.company_name && (
          <>
            <ListItem className={classes.listItem}>
              <ListItemIcon>
                <ApartmentRoundedIcon />
              </ListItemIcon>
              <ListItemText
                primary={t("Company")}
                secondary={data.company_name}
                id={mainPageIDs.company}
              />
            </ListItem>
            <Divider />
          </>
        )}
        {/*  */}
        {data.driver && (
          <>
            <ListItem className={classes.listItem}>
              <ListItemIcon>
                <LocalShippingIcon />
              </ListItemIcon>
              <ListItemText
                primary={t("Driver")}
                secondary={data.driver.first_name + " " + data.driver.last_name}
                id={mainPageIDs.driver}
              />
            </ListItem>
            <Divider />
          </>
        )}

        {data.stop_address?.street && (
          <>
            <ListItem className={classes.listItem}>
              <ListItemIcon>
                <PlaceIcon />
              </ListItemIcon>
              <ListItemText
                primary={t("Destination")}
                secondary={`${data.stop_address.street}${
                  data.stop_address.postal_code
                    ? `, ${data.stop_address.postal_code}`
                    : ""
                }${
                  data.stop_address.city ? `, ${data.stop_address.city}` : ""
                }`}
              />
            </ListItem>
            <Divider />
          </>
        )}
        {data.information?.recipient_name && (
          <>
            <ListItem className={classes.listItem}>
              <ListItemIcon>
                <PersonIcon />
              </ListItemIcon>
              <ListItemText
                primary={t("Recipient")}
                secondary={data.information.recipient_name}
                id={mainPageIDs.recipient}
              />
            </ListItem>
            <Divider />
          </>
        )}
      </List>
      {!screenSm && <Divider />}
    </div>
  );
}
